import type { PackIaData } from "./client";

export interface PublishReportInput {
  rememberme: string;
  report: PackIaData;
  brandLogoUri: string;
  center: string;
  period: string;
  filename: string;
  expiresInDays?: number;
}

export interface PublishedReport {
  id: string;
  url: string;
  expiresAt: string;
}

export interface ManagedPublishedReport extends PublishedReport {
  center: string;
  period: string;
  filename: string;
  createdAt: string | null;
  revoked: boolean;
}

async function request<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({})) as T & { error?: string };
  if (!response.ok) throw new Error(payload.error || `HTTP ${response.status}`);
  return payload;
}

export function publishReport(input: PublishReportInput): Promise<PublishedReport> {
  return request<PublishedReport>("/api/reports/publish", input);
}

export function revokePublishedReport(rememberme: string, id: string): Promise<void> {
  return request<void>("/api/reports/revoke", { rememberme, id });
}

export function updatePublishedReportExpiry(rememberme: string, id: string, expiresAt: string): Promise<{ id: string; expiresAt: string }> {
  return request<{ id: string; expiresAt: string }>("/api/reports/update-expiry", { rememberme, id, expiresAt });
}

export function listPublishedReports(rememberme: string): Promise<{ reports: ManagedPublishedReport[] }> {
  return request<{ reports: ManagedPublishedReport[] }>("/api/reports/list", { rememberme });
}
